import React, { useState } from "react";
import { useSnackbar } from "../../context/snackbar.context.js";
import Card from "@mui/material/Card";
import { Handle, Position } from "@xyflow/react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import MatchResultModal from "../modals/matchResult.modal";
import {
  closeMatch,
  startMatch,
  editMatchResult,
} from "../../api/tournament.api";
import MatchStartModal from "../modals/startMatch.modal";
import { useAuth } from "../../context/auth.context.js";

const MatchCard = ({ data }) => {
  const [openMatchResultModal, setOpenMatchResultModal] = useState(false);
  const [openMatchStartModal, setOpenMatchStartModal] = useState(false);
  const auth = useAuth();
  const showSnackbar = useSnackbar();

  const handleOpenModal = () => {
    if (auth.user.role === "Admin") {

      console.log(data.match);
      if (data.match.status === "Running" || data.match.status === "Closed") {
        setOpenMatchResultModal(true);
      }
      if (data.match.status === "Waiting") {
        setOpenMatchStartModal(true);
      }
    }
  };

  const handleMatchResultCloseModal = () => {
    setOpenMatchResultModal(false);
  };

  const handleMatchResultSubmit = (formData) => {
    var result = { ...data.match, participants: formData };

    console.log(data.match);

    if (data.match.status === "Running") {
      closeMatch(data.tournamentId, result)
        .then(() => {
          data.refresh();
          showSnackbar("Match closed successfully!", "success");
        })
        .catch((error) => {
          console.log(error);
          showSnackbar("Failed to close match!", "error");
        });
    } else {
      editMatchResult(data.tournamentId, result)
        .then(() => {
          data.refresh();
          showSnackbar("Match edited successfully!", "success");
        })
        .catch((error) => {
          console.log(error);
          showSnackbar("Failed to edit match!", "error");
        });
    }
  };

  const handleMatchStartCloseModal = () => {
    setOpenMatchStartModal(false);
  };

  const handleMatchStartSubmit = () => {
    startMatch(data.tournamentId, data.match)
      .then(() => {
        data.refresh();
        showSnackbar("Match started successfully!", "success");
      })
      .catch((error) => {
        console.log(error);
        showSnackbar("Failed to start match!", "error");
      });
  };

  return (
    <>
      {data.match.previousMatches.length > 0 && (
        <Handle
          type="target"
          position={Position.Left}
          style={{ borderRadius: 0, width: 1, height: 1 }}
        />
      )}
      <Card
        sx={{ minWidth: 200, maxWidth: 200, padding: 1 }}
        onClick={handleOpenModal}
        className={`card ${data.match.status.toLowerCase()}`}
      >
        <TableContainer>
          <Table>
            <TableBody>
              {data.match.participants.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    <Typography
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px",
                      }}
                    >
                      {row.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ color: row.isWinner ? "green" : "red" }}>
                      {row.points}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <div>
        <MatchResultModal
          aria-modal
          open={openMatchResultModal}
          handleClose={handleMatchResultCloseModal}
          handleSubmit={handleMatchResultSubmit}
          matchData={data.match}
        />
        <MatchStartModal
          aria-modal
          open={openMatchStartModal}
          handleClose={handleMatchStartCloseModal}
          handleSubmit={handleMatchStartSubmit}
          matchData={data.match}
        />
      </div>
      {data.match.followingMatches.length > 0 && (
        <Handle
          type="source"
          position={Position.Right}
          style={{ borderRadius: 0, width: 1, height: 1 }}
        />
      )}
    </>
  );
};

export default MatchCard;
